import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route change; for hash URLs, waits for the target to mount then scrolls to it.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      return;
    }
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    let timer;
    const attempt = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "instant", block: "start" });
        // Re-align once after late layout shifts (images/fonts).
        timer = setTimeout(() => el.scrollIntoView({ behavior: "instant", block: "start" }), 400);
        return;
      }
      if (tries++ < 40) timer = setTimeout(attempt, 75);
    };
    attempt();
    return () => clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}
